var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.currentView === 'thankyou')?_c('UninstallThankYou'):_c('UninstallCautions',{on:{"continue":_vm.handleContinue}})}
var staticRenderFns = []

export { render, staticRenderFns }